import { AccordionItemUIProps } from '@app/interfaces/userInterface';
import React, { useRef } from 'react';

import { ChevronLeftV2Icon } from '../icons/icons-list';

import { Loading } from '../index';

const AccordionItemUI: React.FC<AccordionItemUIProps> = (props) => {
  const { variant = 'default', active, disabled, dataId, classname, bottomWithoutBorder } = props;

  const containerRef = useRef<HTMLDivElement>(null); // ref на контейнер

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    let targetElement = event.target as HTMLElement;

    while (targetElement && targetElement !== containerRef.current) {
      if (targetElement.classList.contains('danger')) {
        return;
      }
      targetElement = targetElement.parentElement as HTMLElement;
    }

    const params = { id: props.id };
    props.clickBtnChild?.(params);
  };

  return (
    <div
      ref={containerRef}
      key={props.id}
      className={`${variant === 'default' ? 'mb-[22px]' : active ? '' : 'mb-[2px]'}`}
    >
      <div
        data-id={dataId}
        {...{ 'data-status': active }}
        onClick={handleClick}
        className={`${classname} flex cursor-pointer items-center ${
          disabled && 'pointer-events-none'
        } ${
          variant === 'default'
            ? 'h-[34px]'
            : `h-[46px] bg-bg_1 px-[12px]  ${
                bottomWithoutBorder
                  ? props.active
                    ? 'rounded-t-[12px]'
                    : 'rounded-[12px]'
                  : 'rounded-[12px]'
              }`
        }`}
      >
        <div
          className={`flex items-center mb-0 cursor-pointer ${
            variant === 'default' ? 'mr-4 ' : ' mr-[6px]'
          }`}
        >
          <div
            className={`flex items-center text-left transition focus:outline-none ${
              variant === 'default'
                ? 'relative justify-center bg-bg-4 h-[24px] w-[24px] rounded-full text-base'
                : ''
            }`}
            id={`IDACCORDIONBTN${props.id}`}
            // onClick={() => {
            //   const params = {
            //     id: props.id,
            //   };
            //   props.clickBtnChild?.(params);
            // }}
          >
            <ChevronLeftV2Icon
              size={9}
              className={`${
                variant === 'default'
                  ? 'text-gray-800'
                  : 'text-action w-[24px] h-[24px] flex items-center justify-center'
              } transition-all duration-200 ${
                variant === 'default'
                  ? props.active
                    ? 'rotate-[270deg]'
                    : 'rotate-[180deg]'
                  : props.active
                  ? 'rotate-[90deg]'
                  : 'rotate-[270deg]'
              }`}
            />
          </div>
        </div>
        {props.title}
      </div>
      <div
        id={`ID${props.id}`}
        className={`border-0 transition-all duration-200   ${!props.active && 'max-h-0'} ${
          !props.active && 'hidden'
        }`}
      >
        <div className={`${variant === 'default' ? 'py-4' : 'pb-[2px]'}`}>
          {props.loading ? <Loading /> : props.children}
        </div>
      </div>
    </div>
  );
};

export default AccordionItemUI;
